/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_AllInputs */

const en_settings_payments_tab_all = /** @type {(inputs: Settings_Payments_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const zh_settings_payments_tab_all = /** @type {(inputs: Settings_Payments_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Settings_Payments_Tab_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_all = /** @type {((inputs?: Settings_Payments_Tab_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_tab_all(inputs)
	return zh_settings_payments_tab_all(inputs)
});
export { settings_payments_tab_all as "settings.payments.tab_all" }